var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
var sizeClasses = function (size, def) {
    var _a;
    if (def === undefined) {
        return null;
    }
    else if (typeof def === 'number' || typeof def === 'string') {
        return "ffe-grid__col--".concat(size, "-").concat(def);
    }
    return classNames((_a = {},
        _a["ffe-grid__col--".concat(size, "-").concat(def.cols)] = def.cols || def.cols === 0,
        _a["ffe-grid__col--".concat(size, "-offset-").concat(def.offset)] = def.offset || def.offset === 0,
        _a));
};
var centerTextClass = function (centerText) {
    return centerText ? 'ffe-grid__col--center-text' : null;
};
var centerClass = function (center) {
    return center ? 'ffe-grid__col--center' : null;
};
var backgroundClass = function (bgColor) {
    return bgColor ? "ffe-grid__col--bg-".concat(bgColor) : null;
};
export var GridCol = function (_a) {
    var bgColor = _a.bgColor, className = _a.className, _b = _a.as, Comp = _b === void 0 ? 'div' : _b, centerText = _a.centerText, center = _a.center, children = _a.children, sm = _a.sm, md = _a.md, lg = _a.lg, rest = __rest(_a, ["bgColor", "className", "as", "centerText", "center", "children", "sm", "md", "lg"]);
    return (React.createElement(Comp, __assign({ className: [
            'ffe-grid__col',
            className,
            sizeClasses('lg', lg),
            sizeClasses('md', md),
            sizeClasses('sm', !sm && !lg && !md ? 12 : sm),
            centerTextClass(centerText),
            centerClass(center),
            backgroundClass(bgColor),
        ]
            .filter(function (x) { return x; })
            .join(' ') }, rest), children));
};
